<template>
    <div>
        <GChart
            type="ColumnChart"
            :settings="{packages: ['corechart'], language: 'pt-br'}"
            :data="chartDataFinal"
            :options="chartOptions"
        />
    </div>
</template>

<script>
export default {
    props: ['chartData', 'currency'],
    data() {
        return {
            chartOptions: {
                fontName: 'Muli',
                height: 400,
                legend: { position: 'top', maxLines: 3 },
                bar: { groupWidth: '75%' },
                isStacked: true,
                chartArea: {
                    width: '90%'
                },
                vAxis: {
                    format: 'decimal'
                }
            }
        }
    },
    computed: {
        chartDataFinal() {
            return this.chartData
        }
    },
    created() {
        this.chartDataFinal.unshift(['', this.__('reports.Invested'), this.__('reports.Result'), { role: 'annotation' } ])
    }
}
</script>

<style scoped>

</style>
